/**
 * Generates an array containing all weeks in a given range.
 * Weeks start on Saturday at 12:00 AM UTC and end on Friday at 11:59 PM UTC
 * @param {Date} startDate start date of range
 * @param {Date} endDate end date of range
 * @returns {[*]} array of weeks
 */
export function getWeeksInRange(startDate, endDate) {
  const weeks = [];
  const start = new Date(startDate);
  const end = new Date(endDate);

  // Set the start date to the first Saturday on or before the given start date
  // Saturday is day 6, so we calculate days back to Saturday
  const dayOfWeek = start.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
  const daysBackToSaturday = dayOfWeek === 6 ? 0 : (dayOfWeek + 1);
  start.setDate(start.getDate() - daysBackToSaturday);
  start.setHours(0, 0, 0, 0);

  // Loop through each week until we reach or pass the end date
  while (start < end) {
      const weekStart = new Date(start);
      const weekEnd = new Date(start);
      weekEnd.setDate(weekEnd.getDate() + 6); // Add 6 days to get to Friday
      weekEnd.setHours(23, 59, 59, 999);

      weeks.push({ startDate: weekStart, endDate: weekEnd });

      // Move to the next Saturday
      start.setDate(start.getDate() + 7);
  }

  return weeks;
}

/**
 * checks whether a date is within a range of two dates
 * @param {Date|string} date date to check
 * @param {Date|string} startDate start date of range
 * @param {Date|string} endDate end date of range
 * @returns 
 */
export function isDateInRange(date, startDate, endDate) {
  return new Date(date) >= new Date(startDate) && new Date(date) <= new Date(endDate);
}